module.exports = __webpack_public_path__ + "static/logo-171b32cb05b848dba7852a84392adadb.png";